import { render, staticRenderFns } from "./ImageSlider.vue?vue&type=template&id=584c5ee1&"
import script from "./ImageSlider.vue?vue&type=script&lang=js&"
export * from "./ImageSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('584c5ee1')) {
      api.createRecord('584c5ee1', component.options)
    } else {
      api.reload('584c5ee1', component.options)
    }
    module.hot.accept("./ImageSlider.vue?vue&type=template&id=584c5ee1&", function () {
      api.rerender('584c5ee1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/ImageSlider.vue"
export default component.exports